import React from 'react';
import { getRouteApi, useLocation } from '@tanstack/react-router';

const UsefulInfo = React.lazy(() => import('../components/UsefulInfo/UsefulInfo'));

const routeApi = getRouteApi('/useful-info/$slug');

const InfoPage = () => {
    const { usefulInfoData } = routeApi.useLoaderData();

    return (
        <React.Suspense fallback={<div>Loading...</div>}>
            <UsefulInfo initialUsefulInfoData={usefulInfoData} />
        </React.Suspense>
    );
};

export default InfoPage